module.exports = __webpack_public_path__ + "sansg/img/applybanner.48a6f395.jpg";